import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColumnDef } from '@tanstack/react-table';
import JsonToCsvButton from 'components/JsonToCsvButton';
import InActiveSiteCardViewItem from 'components/modules/project-management/card-view/InActiveSiteCardViewItem';
import InActiveSiteListViewItem from 'components/modules/project-management/card-view/InActiveSiteListViewItem';
import SiteCardViewItem from 'components/modules/project-management/card-view/SiteCardViewItem';
import SiteListViewItem from 'components/modules/project-management/card-view/SiteListViewItem';
// import SiteListViewItem from 'components/modules/project-management/card-view/SiteListViewItem';
import { Site } from 'data/project-management/projects';
import Loader from 'helpers/Loader';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getService } from 'services/services';

export const columns: ColumnDef<Site>[] = [
  {
    // For filtering and searching projects by status
    id: 'site_id',
    accessorFn: ({ site_id }) => site_id
  },
  {
    // For searching projects by name
    accessorKey: 'name'
  }
];

const InActiveSiteListCardView = () => {
  const [siteList, setSiteList] = useState<Site[]>([]);
  const [workOrder, setWorkOrder] = useState<any[]>([]);
  const [contractor, setContractor] = useState<any[]>([]);
  const [siteName, setSiteName] = useState<any[]>([]);
  const [siteId, setSiteId] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [role, setRole] = useState(0);
  const [viewUi, setViewUi] = useState(false);
  // const [viewUi, setViewUi] = useState(true);
  const [woFilter, setWoFilter] = useState('');
  const [contFilter, setContFilter] = useState('');
  const [siteFilter, setSiteFilter] = useState('');

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const role = Number(localStorage.getItem('role'));
      setRole(role);
    }
  }, []);

  // For filtering the original list
  const [filteredSiteList, setFilteredSiteList] = useState<Site[]>([]);

  useEffect(() => {
    fetch();
    fetchWorkOrder();
    fetchContractor();
  }, []);

  const fetch = async () => {
    setLoading(true);
    const response = await getService('site_inactive');
    if (response.status === 200) {
      setLoading(false);
      setSiteList(response.data);
      setSiteName(response.data);
      setSiteId(response.data);
      setFilteredSiteList(response.data); // Initialize filtered list
    } else {
      setLoading(false);
    }
  };

  const fetchWorkOrder = async () => {
    const response = await getService('workorder');
    if (response.status === 200) {
      setWorkOrder(response.data);
    } else {
      console.log('Error');
    }
  };

  const fetchContractor = async () => {
    const response = await getService('contractor');
    if (response.status === 200) {
      setContractor(response.data);
    } else {
      console.log('Error');
    }
  };

  useEffect(() => {
    const fetchFilteredSites = async () => {
      const response = await getService(
        `site_inactive/${woFilter ? woFilter : '0'}/${
          contFilter ? contFilter : '0'
        }/${siteFilter ? siteFilter : '0'}`
      );
      if (response.status === 200) {
        setSiteList(response.data);
      } else {
        console.log('Error');
      }
    };

    // Only call the API if any filter is set (not '0')
    if (woFilter !== '' || contFilter !== '' || siteFilter !== '') {
      fetchFilteredSites();
    }
  }, [woFilter, contFilter, siteFilter]); // Dependency array ensures API is called when any filter changes

  // handleFilter function
  const handleFilter = (data: any, name: string) => {
    if (name === 'site') {
      setSiteFilter(data);
    } else if (name === 'wo') {
      setWoFilter(data);
    } else if (name === 'siteId') {
      setSiteFilter(data);
    } else if (name === 'contractor') {
      setContFilter(data);
    }
  };

  // Update filteredSiteList based on searchTerm
  useEffect(() => {
    if (searchTerm === '') {
      setFilteredSiteList(siteList); // Reset to original list
    } else {
      const lowerCaseTerm = searchTerm.toLowerCase();
      const filteredItems = siteList.filter((item: any) =>
        item.site_name.toLowerCase().includes(lowerCaseTerm)
      );
      setFilteredSiteList(filteredItems); // Update filtered list
    }
  }, [searchTerm, siteList]);

  const filteredData = siteList.map((data: any) => ({
    site_name: data.site_name,
    site_id: data.id,
    Work_Order_No: data.workorder.name,
    budget: data.budget,
    address: data.address,
    start_date: data.start_date,
    end_date: data.end_date,
    sac_code: data.sac_code,
    uom: data.uom,
    workorder_id: data.workorder.wo_id,
    contractor_name: `${data?.contractor?.first_name} ${data?.contractor?.last_name}`
  }));

  const table = useAdvanceTable<Site>({
    data: filteredSiteList,
    columns,
    pageSize: 1000,
    pagination: true,
    sortable: true
  });
  if (loading) return <Loader />;
  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">InActive Sites</span>{' '}
            <span className="fw-normal text-body-tertiary">
              ({siteList.length})
            </span>
          </h2>
          <Button variant="info" onClick={() => setViewUi(!viewUi)}>
            {viewUi ? 'List View' : 'Card View'}
          </Button>
          <Col xs={4} sm={3} md={2} lg={2}>
            <Form.Select
              name="Material Filter"
              onChange={e => handleFilter(e.target.value, 'site')}
            >
              <option value="0">Select Site</option>
              {siteName.length > 0 &&
                siteName.map((item: any) => (
                  <option key={item.id} value={item.id}>
                    {item.site_name}
                  </option>
                ))}
            </Form.Select>
          </Col>
          <Col xs="auto">
            <Form.Select
              name="WorkOrder Filter"
              onChange={e => handleFilter(e.target.value, 'wo')}
            >
              <option value="0">Select WO</option>
              {workOrder.length > 0 &&
                workOrder.map((item: any) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
            </Form.Select>
          </Col>
          {/* <Col xs="auto">
            <Form.Select
              name="Material Filter"
              onChange={e => handleFilter(e.target.value, 'siteId')}
            >
              <option value="0">Select Site Id</option>
              {siteId.length > 0 &&
                siteId.map((item: any) => (
                  <option key={item.id} value={item.id}>
                    {item.id}
                  </option>
                ))}
            </Form.Select>
          </Col> */}
          <Col xs="auto">
            <Form.Select
              name="Material Filter"
              onChange={e => handleFilter(e.target.value, 'contractor')}
            >
              <option value="0">Contractor</option>
              {contractor.length > 0 &&
                contractor.map((item: any) => (
                  <option key={item.id} value={item.id}>
                    {`${item.first_name} ${item.last_name}`}
                  </option>
                ))}
            </Form.Select>
          </Col>
          {viewUi && (
            <Form>
              <Form.Group controlId="searchForm">
                <Form.Control
                  type="text"
                  name="searchTerm"
                  placeholder="Search Sites..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </Form.Group>
            </Form>
          )}
          <JsonToCsvButton
            data={filteredData}
            filename="In Active sites Report.csv"
          />
        </div>

        {/* <ProjectsTopSection activeView="card" /> */}
        {/* <div className="d-flex mb-3">
          <Link to="#" className="me-2 tex">
            All({siteList.length})
          </Link>
          <>
            <Link to="#" className="tex">
              3 Day to go
            </Link>
            <p className="me-2 tex" style={{ color: 'orange' }}>
              (0)
            </p>
          </>{' '}
          <>
            <Link to="#" className="tex">
              5 Day to go
            </Link>
            <p className="me-2 tex" style={{ color: 'yellow' }}>
              (0)
            </p>
          </>
          <>
            <Link to="#" className="tex">
              Same
            </Link>
            <p className="me-2 tex" style={{ color: 'red' }}>
              (0)
            </p>
          </>
          <>
            <Link to="#" className="tex">
              Overdue
            </Link>
            <p className="me-2 tex" style={{ color: 'red' }}>
              (0)
            </p>
          </>
        </div> */}
        {viewUi && (
          <Row className="g-3 mb-9">
            {table
              .getRowModel()
              .rows.map(row => row.original)
              .map(site => (
                <Col xs={12} sm={6} xl={4} xxl={3} key={site.id}>
                  <InActiveSiteCardViewItem project={site} />
                </Col>
              ))}
          </Row>
        )}
        {!viewUi && <InActiveSiteListViewItem siteList={siteList} />}
      </AdvanceTableProvider>
    </div>
  );
};

export default InActiveSiteListCardView;
